import { useMemo } from 'react';
import { formatBaseline } from '../utils/formatTraces';

const useBaselineTrace = (
  baseLine: string | undefined | null,
  baselineEnabled: boolean | undefined,
  disableTraces: boolean | undefined
) => {
  const formattedBaseline = useMemo(
    () => formatBaseline(baseLine, baselineEnabled, disableTraces),
    [baseLine, baselineEnabled, disableTraces]
  );

  return formattedBaseline;
};

export default useBaselineTrace;
